<template lang="html">
  <div class="eb-pt-row-login">
    <div class="row justify-content-md-center mx-1 mt-3">
      <div :class="formContainerClass">
        <div class="row justify-content-md-center">
          <div class="col">
            <div>
              <template v-if="!hideTitle">
                <h4 class="text-center mb-4 mt-4">
                  Sign up
                </h4>
              </template>
              <form>
                <div
                  v-show="!linkAccountMode"
                  class="form-group"
                >
                  <label
                    for="Email"
                    style="display:none;"
                  >Email</label>
                  <input
                    id="Email"
                    v-model="signupModel.Email"
                    type="email"
                    class="form-control"
                    placeholder="Email"
                  >
                  <div class="message_error_login email_error">
                    {{ validation.firstError('signupModel.Email') }}
                  </div>
                </div>
                <div
                  v-show="!linkAccountMode"
                  class="form-group"
                >
                  <label
                    for="Password"
                    style="display:none;"
                  >Password</label>
                  <input
                    id="Password"
                    v-model="signupModel.Password"
                    type="password"
                    class="form-control"
                    placeholder="Password"
                  >
                  <div class="message_error_login password_error">
                    {{ validation.firstError('signupModel.Password') }}
                  </div>
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col mr-2">
                      <label
                        for="FirstName"
                        style="display:none;"
                      >First Name</label>
                      <input
                        id="FirstName"
                        v-model="signupModel.FirstName"
                        type="text"
                        class="form-control"
                        placeholder="First name"
                      >
                      <div class="message_error_login firstname_error">
                        {{ validation.firstError('signupModel.FirstName') }}
                      </div>
                    </div>
                    <div class="col">
                      <label
                        for="LastName"
                        style="display:none;"
                      >Last Name</label>
                      <input
                        id="LastName"
                        v-model="signupModel.LastName"
                        type="text"
                        class="form-control"
                        placeholder="Last name"
                      >
                      <div class="message_error_login lastname_error">
                        {{ validation.firstError('signupModel.LastName') }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col-md-4 col-sm-6 col-xs-12 pr-md-0">
                      <label class="font-weight-bold opacity-lavel mr-3">Date of Birth:</label>
                    </div>
                    <div class="col-md-8 col-sm-6 col-xs-12 et_pickedDate">
                      <date-dropdown
                        v-model="signupModel.DateOfBirth"
                        min="1920"
                        max="2018"
                        default="1991-01-01"
                        @date-of-birth-updated="onDateOfBirthUpdated"
                      />
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="text-danger">
                    {{ serverMessage }}
                  </div>
                </div>
                <div class="text-center">
                  <slot name="terms"></slot>
                </div>
                <div class="form-group mt-4 mb-0">
                  <div class="row justify-content-md-center">
                    <div class="col-xs-12 col-md-8">
                      <button
                        id="btnSubmit"
                        type="button"
                        class="btn btn-block gf-driver-button-color gf-driver-background-bg"
                        @click="submitRegistration"
                      >
                        <span class="primary-text">Sign Up</span>
                      </button>
                    </div>
                  </div>
                </div>
                <br>
              </form>
            </div>
          </div>
          <!-- component facebook -->
          <LoginFacebookInitializer
            v-show="!inApp && facebook.appId != '' && showFacebookButton"
            :facebook="facebook"
            action-type="RegisterUser"
            :return-url="returnUrl"
            @tokenError="onTokenError"
          />
          <!-- end component facebook -->
          <div class="col-md-12">
            <p class="font-weight-normal text-center w-100 pb-4" :class="!hideLoginLink ? 'bd-hr-col' : ''">
              <a href="javascript:;" @click="router().show('forgot-password')">
                Forgot your Password?
              </a>
            </p>
          </div>
          <template v-if="!hideLoginLink">
            <div class="col-md-12 pt-2">
              <p class="d-inline pl-5">
                Have an existing account?
              </p>
              <p class="d-inline pr-5 float-right">
                <a href="javascript:;" 
                  @click="router().show('login', {
                    accountLink: linkAccountMode, 
                    accessToken: accessToken, 
                    returnUrl: returnUrl 
                  })"
                >
                  Log in
                </a>
              </p>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import RegisterInitializer from './RegisterInitializer.vue'
import LoginFacebookInitializer from '../login/LoginFacebookInitializer.vue'
import DateDropdown from '../date-dropdown/DateDropdown.vue'
import useAppRouter from '../../composables/useAppRouter'

export default {
  components: { LoginFacebookInitializer, DateDropdown },
  mixins: [RegisterInitializer],
  props: {
    facebook: {
      type: Object
    },
    returnUrl: {
      type: String,
      default: ''
    },
    formContainerClass: {
      type: String,
      default: ''
    },
    accountLink: {
      type: Boolean
    },
    accessToken: {
      type: String,
      default: ''
    },
    disableRedirect: {
      type: Boolean,
      default: false
    },
    hideTitle: {
      type: Boolean,
      default: false
    },
    hideLoginLink: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      inApp: false,
      showFacebookButton: false,
      router: useAppRouter
    }
  },
  mounted() {
    this.linkAccountMode = this.accountLink

    if (
      this.router().getRouteParams('accountLink') &&
      this.router().getRouteParams('accountLink') === true
    ) {
      this.linkAccountMode = true
    }

    if (
      this.router().getRouteParams('accessToken') &&
      this.router().getRouteParams('accessToken').length > 0
    ) {
      this.accountAccessToken = this.router().getRouteParams('accessToken')
    }

    var ua = navigator.userAgent || navigator.vendor || window.opera
    this.inApp = ua.indexOf('FBAN') > -1 || ua.indexOf('FBAV') > -1

    this.showFacebookButton = !this.linkAccountMode
    this.$gfLogger.logInfo(`accessToken: ${this.accountAccessToken}`)
    this.$gfLogger.logInfo(`link account mode: ${this.linkAccountMode}`)
  },
  methods: {
    onDateOfBirthUpdated: function (dateOfBirth) {
      this.signupModel.DateOfBirth = dateOfBirth
    },
    onTokenError: function (message) {
      this.serverMessage = message
    }
  }
}
</script>
